const campaignData = [
]

export default campaignData;